import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/organization/organizationAction";
import * as uiHelpers from "../OrganizationUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useOrganizationUIContext } from "../OrganizationUIContext";
import { RoleChecker } from "../../../../../RoleChecker";
import {
  organizationStatusFormatter,
  ORGANIZATION_STATUS,
  SIMPZ_STATUS
} from "../../../../../config/helper";
import { useLocation } from "react-router-dom";
import moment from "moment";
// import { ToastContainer } from 'react-toastify';

const OrganizationTable = ({
  match: { params },
  setCurrentOrg,
  setModal,
  allowEdit
}) => {
  // Organization UI Context
  const organizationUIContext = useOrganizationUIContext();
  const organizationUIProps = useMemo(() => {
    return {
      queryParams: organizationUIContext.queryParams,
      setQueryParams: organizationUIContext.setQueryParams,
      openEditOrganizationPage: organizationUIContext.openEditOrganizationPage,
      openOrganizationFilePage: organizationUIContext.openOrganizationFilePage
    };
  }, [organizationUIContext]);

  // Getting curret state of organization list from store (Redux)
  const { currentState } = useSelector(
    state => ({ currentState: state.organizations }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;
  console.log(`entities`, entities);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true
      // sortCaret: sortCaret,
    },
    // ? STATUS PAYMENT UNTUK DONORIAN
    // {
    //   dataField: "status",
    //   text: "Status",
    //   sort: true,
    //   formatter: cell => {
    //     let color;
    //     switch (cell) {
    //       case ORGANIZATION_STATUS.ALLOW:
    //         color = "primary";
    //         break;
    //       case ORGANIZATION_STATUS.PAID:
    //         color = "success";
    //         break;
    //       case ORGANIZATION_STATUS.BLOCK:
    //         color = "danger";
    //         break;

    //       default:
    //         color = "";
    //         break;
    //     }

    //     return (
    //       cell && (
    //         <span
    //           className={`label label-lg label-light-${color} label-inline`}
    //         >
    //           {organizationStatusFormatter(cell)}
    //         </span>
    //       )
    //     );
    //   }
    // },
    params.value !== "is_nearly_expired" && {
      dataField: "is_activated",
      text: "Status Aktif",
      classes: "text-nowrap",
      sort: true,
      formatter: (cell, row) => {
        let color;
        if (cell) {
          color = "success";
        } else {
          color = "danger";
        }
        return (
          <span className={`label label-lg label-light-${color} label-inline`}>
            {cell ? "AKTIF" : "TIDAK AKTIF"}
          </span>
        );
      }
    },
    {
      dataField: "registration_date",
      text: "Tanggal Pendaftaran",
      sort: true
    },
    {
      dataField: "start_date",
      text: "Tanggal Aktif",
      sort: true
    },
    {
      dataField: "end_date",
      text: "Aktif Sampai Dengan",
      sort: true
    },
    params.value !== "SUBMIT" && {
      dataField: "end_date",
      text: "Status Expired",
      sort: true,
      formatter: (cell, row) => {
        const currentDate = moment().format("YYYY-MM-DD");
        let color;
        if (cell > currentDate) {
          color = "success";
        } else {
          color = "warning";
        }
        return (
          <>
            {cell && (
              <span
                className={`label label-lg label-light-${color} label-inline`}
              >
                {cell > currentDate ? "AKTIF" : "EXPIRED"}
              </span>
            )}
          </>
        );
      }
    },
    {
      dataField: "updated_at",
      text: "Terakhir Login",
      classes: "text-nowrap",
      formatter: (cell, row) => {
        const date = moment(cell).format("YYYY-MM-DD HH:mm");
        if (
          [
            SIMPZ_STATUS.ACTIVE,
            SIMPZ_STATUS.DATA_UPLOAD,
            SIMPZ_STATUS.SUBMIT
          ].includes(row.simpz_status)
        ) {
          return <span>{date}</span>;
        }
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditOrganizationPage: organizationUIProps.openEditOrganizationPage,
        openOrganizationFilePage: organizationUIProps.openOrganizationFilePage,
        allowEdit,
        setCurrentOrg,
        setModal
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: organizationUIProps.queryParams.pageSize,
    page: organizationUIProps.queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  organizationUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default OrganizationTable;
